/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5c-.9575 0-1.8839-.128-2.7636-.3673a.75.75 0 0 0-.3938 1.4474A12.0147 12.0147 0 0 0 12 24c6.6274 0 12-5.3726 12-12S18.6274 0 12 0 0 5.3726 0 12c0 1.0917.146 2.1505.42 3.1574a.75.75 0 1 0 1.4474-.3938A10.513 10.513 0 0 1 1.4999 12Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.3297 7.501c.484-.484.6199-1.1836.5241-1.7557-.0961-.5738-.4816-1.257-1.2857-1.4053-2.3744-.4375-4.9206.2617-6.7591 2.1002-2.2069 2.2069-2.7723 5.4316-1.7 8.1601L.89 18.8192c-1.1848 1.1848-1.1848 3.1058 0 4.2907 1.1849 1.1848 3.1059 1.1848 4.2907 0l4.2189-4.2189c2.7285 1.0723 5.9532.5069 8.1601-1.7 1.8385-1.8385 2.5377-4.3847 2.1002-6.7591-.1482-.8041-.8315-1.1896-1.4052-1.2857-.5722-.0958-1.2717.0401-1.7557.5241l-3.23 3.23c-.5991.5991-1.5704.5991-2.1694 0-.5991-.599-.5991-1.5703 0-2.1694l3.23-3.23Zm-1.0328-1.6858c.0012-.0003.0037-.0007.0143.0124.0184.0227.0482.076.0632.1654.0334.1998-.0336.3755-.1054.4473l-3.23 3.23c-1.1848 1.1848-1.1848 3.1058 0 4.2907 1.1849 1.1848 3.1059 1.1848 4.2907 0l3.23-3.23c.0718-.0718.2475-.1388.4473-.1054.0894.015.1427.0448.1654.0632.0131.0106.0127.0131.0124.0143.352 1.9099-.2108 3.9523-1.6857 5.4272-1.8669 1.8669-4.644 2.2722-6.906 1.2117a.8204.8204 0 0 0-.9282.1625l-4.5447 4.5447c-.599.5991-1.5704.5991-2.1694 0-.599-.599-.599-1.5703 0-2.1694l4.5447-4.5447a.8201.8201 0 0 0 .1625-.9281c-1.0605-2.2621-.6552-5.0392 1.2116-6.9061 1.475-1.4749 3.5174-2.0377 5.4273-1.6857Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuSubAPIManagement'
);
